import listing from "../api/listing";
import page from "../api/page";
import pageCategory from "../api/page-category";
import filterTag from "../api/filterTag";
import career from "../api/career";
import { resolve } from "path";
import { reject } from "lodash";
export default {
  getListings({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await listing.getListings();

        commit("SET_LISTINGS", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getpagebycategory({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await page.getpagebycategory(payload);

        commit("SET_CATEGORYWISEPAGE", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  GetPagesbyCategoryForBlog({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await page.getPagesbyCategoryForBlog(payload);

        commit("SET_CATEGORYWISEPAGE", data.data);
        // commit("SET_CATEGORYWISEPAGEFORBLOG", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  GetPagesbyCategoryForEvent({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await page.getPagesbyCategoryForEvent(payload);
        // console.log(data.data[0]);
        commit("SET_CATEGORYWISEPAGEFOREVENT", data.data[0]);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getPages({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await page.getPages();

        commit("SET_PAGES", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getPageByTags({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await page.getPageByTags(payload);

        commit("SET_PAGES", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getPage({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await page.getSinglePage(payload);

        commit("SET_PAGE", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  addPage({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await page.addPage(payload);
        // console.log(data);
        commit("ADD_PAGE", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getPageCategories({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await pageCategory.getPageCategories(payload);

        commit("SET_PAGE_CATEGORIES", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getTagsbyCategory({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await filterTag.getTagsbyCategory(payload);

        commit("SET_CATEGORIES_TAGS", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getfilterbycategory({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await filterTag.getfilterbycategory(payload);

        commit("SET_FILTERS", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  GetTagsbyFilter({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await filterTag.GetTagsbyFilter(payload);

        commit("SET_FILTER_TAGS", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deletePage({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await page.deletePage(payload);

        commit("DELETE_PAGE", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getRelatedPages({ }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await page.getPages(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  subscribeToNewsletter({ }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await pageCategory.subscribeToNewsletter(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editPage({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await page.editPage(payload);
        commit("EDIT_PAGE", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  bulkEdit({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await page.bulkEdit(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    })
  },
  addCareer({ }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await career.addCareer(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getCareers({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await career.getCareers(payload);
        commit("SET_CAREERS", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  deleteCareer({ }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await career.deleteCareer(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editCareer({ }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await career.editCareer(payload);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getSingleCareer({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await career.getSingle(payload);
        commit("SET_SELECTED_CAREER", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  selfHelpViewers({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await page.selfHelpViewers(payload);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
